import React, { Component } from "react";
import IdentityService from "../../common/identityService";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";

export default class LogoutPage extends Component {

  redirectToLogin() {
    return (
      <Redirect to="/login" />
    )
  }

  async componentDidMount() {
    try {
      await IdentityService.logout();
      this.props.setIsLoggedIn(false);
    } catch (e) {
      this.props.notifyInfo(
          "Successfully logged out"
      );
    }
  }

  render() {
    return (
      <>
        {this.redirectToLogin()}
      </>
    );
  }
}

LogoutPage.propTypes = {
  notifyInfo: PropTypes.func.isRequired,
  notifyFailure: PropTypes.func.isRequired
};
